jQuery(document).ready(function($){
    //Remove link default action
    $('.gridlist-toggle a').on('click', function(event){
        event.preventDefault();
    });

    //Set default to list view
    if($.cookie('gridlist') == null){
        //$('.shop-archive ul.products').addClass('list');
        $('.gridlist-toggle #list').addClass('active');
    }

    //Set active, switch class and set cookie
    $('#grid').click(function() {
        $(this).addClass('active');
        $('#list').removeClass('active');
        $.cookie('gridlist','grid', { path: '/' });
        $('ul.products').fadeOut(300, function() {
            $(this).addClass('grid').removeClass('list').fadeIn(300);
        });
        return false;
    });

    $('#list').click(function() {
        $(this).addClass('active');
        $('#grid').removeClass('active');
        $.cookie('gridlist','list', { path: '/' });
        $('ul.products').fadeOut(300, function() {
            $(this).removeClass('grid').addClass('list').fadeIn(300);
        });
        return false;
    });

    //If cookie is set, set style
    if ($.cookie('gridlist')) {
        $('.shop-archive ul.products').addClass($.cookie('gridlist'));
    }

    //Manage gridlist active navigation based on cookie
    if (jQuery.cookie('gridlist') == 'grid') {
        jQuery('.gridlist-toggle #grid').addClass('active');
        jQuery('.gridlist-toggle #list').removeClass('active');
    }

    if (jQuery.cookie('gridlist') == 'list') {
        jQuery('.gridlist-toggle #list').addClass('active');
        jQuery('.gridlist-toggle #grid').removeClass('active');
    }
});